<template>
  <main>
    <OrganismConfirmForgotPassword/>
  </main>
</template>

<script>
export default {
  name: 'ConfirmForgotPassword',

  components: {
    OrganismConfirmForgotPassword: () => import('@/components/organisms/OrganismConfirmForgotPassword')
  }
}
</script>
